import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from '../../../utils/createSignedRequest';

export const patchUpdateDefectListData = async (
  projectId,
  defectListId,
  defectListAttributeModifications,
  defectItemsToCreate
  // defectItemAssignationsToCreate
) => {
  const apiPath = `defect-lists/project/${projectId}/list/${defectListId}/update-defect-list-data`;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,

    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'PATCH',
    region: Config.AWS_REGION,
    service: 'execute-api',
    body: JSON.stringify({
      defectListAttributeModifications,
    }),
    data: { defectListAttributeModifications },
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const signedRequest = await createSignedRequest(request);
  const response = await axios(signedRequest);

  return response.data;
};
